<template>
  <button
    type="button"
    class="underline underline-offset-2 decoration-transparent flex items-center gap-1 transition-all ease-out duration-100 hover:decoration-blue-200/50 active:decoration-blue-300 decoration-2 text-blue-700/80 hover:text-blue-400 active:text-blue-600 disabled:cursor-not-allowed disabled:text-gray-600/60 disabled:hover:decoration-transparent disabled:active:decoration-transparent"
    v-bind="$attrs"
  >
    <s-icon name="pencil" size="1em" class="-m-0.5" :aria-label="t('editAll')" />
    <slot />
  </button>
</template>
<script setup lang="ts">
import SIcon from '../design-system/SIcon.vue';
import {useI18n} from 'vue-i18n';

const {t} = useI18n({
  inheritLocale: true,
  useScope: 'local',
});
</script>
<i18n>
{
  "en": {
    "editAll": "Edit all"
  },
  "fr": {
    "editAll": "Modifier tout"
  }
}
</i18n>
